import { DateTime } from 'luxon'
import Capitalize from 'Lib/Capitalize'

export const VideoRespTransform = (data) => {
  return data.map(video => {
    return Object.assign(video, {
      createdAt: DateTime.fromISO(video.createdAt).toFormat('MMM d, h:mm:a'),
      username: video.user.name ? Capitalize(video.user.name) : video.user.email
    })
  })
}



// WEBPACK FOOTER //
// ./src/Transforms/Video.js